const color = {
  superprimary: "#000000",
  primary: "#485156",
  subprimary: "#C5CDD3",
  subsubprimary: "#E2E6E9",
  subsubsubprimary: "#f0f2f4",
  neutral: "#FFFFFF",
  highlightOne: "#317BB4",
  highlightTwo: "#E30613",
};

export const theme = {
  color,
  statusColor: {
    upcoming: color.highlightOne,
    live: color.highlightTwo,
    on_demand: color.highlightOne,
    past: color.primary,
    past_not_started: color.highlightTwo,
    canceled: color.subprimary,
    draft: color.primary,
  },
  font: {
    light: '"TitilliumWeb_Light", sans-serif',
    regular: '"TitilliumWeb_Regular", sans-serif',
    medium: '"TitilliumWeb_Medium", sans-serif',
    bold: '"TitilliumWeb_Bold", sans-serif',
    humane: '"Caveat", cursive',
  },
  fontSize: {
    tiny: "10px",
    small: "12px",
    medium: "16px",
    large: "20px",
    big: "32px",
    huge: "60px",
  },
};
